<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="row align-items-center">
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email">
                {{ $t("invoice_number") }}
              </label>
              <app-input
                type="text"
                :read-only="true"
                v-model="inputs.invoice_number"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_name">
                {{ $t("service_name") }}
              </label>
              <app-input
                type="text"
                :read-only="true"
                :placeholder="$t('service_name')"
                v-model="inputs.name"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_quantity">
                {{ $t("service_quantity") }}
              </label>
              <app-input
                type="number"
                :read-only="true"
                :placeholder="$t('service_quantity')"
                v-model="inputs.quantity"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email">
                {{ $t("invoice_date") }}
              </label>
              <app-input
                type="text"
                :read-only="true"
                v-model="inputs.invoice_date"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label>{{ $t("due_date") }}</label>
              <app-input
                type="text"
                v-model="inputs.due_date"
                :read-only="true"
                :placeholder="$t('select_valid_date')"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label>{{ $t("amount") }} {{ inputs.vat != 0 ? ' (Include Vat)' : '' }}</label>
              <app-input
                type="number"
                v-model="inputs.amount"
                :read-only="true"
                :placeholder="$t('amount')"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_vat">
                {{ $t("service_vat") }} (%)
              </label>
              <app-input
                type="number"
                :read-only="true"
                :placeholder="$t('service_vat')"
                v-model="inputs.vat"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label>{{ $t("due_amount") }}</label>
              <app-input
                type="number"
                v-model="inputs.amount_due"
                :read-only="true"
                :placeholder="$t('due_amount')"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label>{{ $t("paid_amount") }}</label>
              <app-input
                type="number"
                v-model="inputs.paid_amount"
                :placeholder="$t('paid_amount')"
              />
            </div>
          </div>
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("company") }}
            </label>
            <app-input
              class="col-sm-9"
              type="search-select"
              :list="this.company"
              :isAnimatedDropdown="true"
              :required="true"
              :placeholder="$t('select_company')"
              v-model="inputs.company"
            />
          </div> -->
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("package") }}
            </label>
            <app-input
              class="col-sm-9"
              type="search-select"
              :list="this.packages"
              :isAnimatedDropdown="true"
              :required="true"
              :placeholder="$t('select_package')"
              v-model="inputs.package"
            />
          </div> -->
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("amount") }}
            </label>
            <app-input
              id="amount"
              class="col-sm-9"
              type="number"
              v-model="inputs.amount"
              :required="true"
            />
          </div> -->
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import {
  CUSTOMER_INVOICE_UPDATE,
  COMPANY_LIST,
  INVOICE_PACKAGE_LIST,
} from "../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      required: false,
      inputs: {
        paid_amount: 0,
        due_amount: 0,
      },
      company: [],
      packages: [],
      status: [
        { id: "", value: "Select Amount Status" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: "Edit",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.preloader = true;
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
        axiosPost(CUSTOMER_INVOICE_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.name = response.data.service_name;

      let vat = response.data.service_vat;
      let amount = response.data.amount
      this.inputs.vat = vat;
      this.inputs.quantity = response.data.service_quantity;
      this.inputs.amount = (amount * (100 + (vat !== null ? vat : 0))) / 100
      this.inputs.amount_due = (response.data.amount_due * (100 + (vat !== null ? vat : 0))) / 100
      this.preloader = false;
    },
    getcompany() {
      axiosGet(COMPANY_LIST)
        .then((response) => {
          
          this.company = response.data;
        })
        .catch((error) => {
          
        });
    },
    getPackages() {
      axiosGet(INVOICE_PACKAGE_LIST)
        .then((response) => {
          
          this.packages = response.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getcompany();
    this.getPackages();
    // this.getPackageInfo();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
